export const BaseGridOptions = {
  enableRtl: true,

  // ... other grid options ...
  localeText: {
    // ... custom translations ...
    notContains: "شامل نشود",
    contains: "شامل شود",
    equals: "برابر باشد با",
    notEqual: "برابر نباشد با",
    startsWith: "شروع شود با",
    endsWith: "پایان یابد با",
    notBlank: "خالی نباشد",
    blank: "خالی باشد",
    loadingOoo: "در حال بارگزاری لطفا منتظر بمانید",
    andCondition: "و",
    orCondition: "یا",
    loadingError: "متاسفانه خطایی در سرور رخ داده است !",
    pageNotFound: "صفحه مورد نظر یافت نشد",
    noRowsToShow: " رکوردی موجود نیست ",
    filterOoo: "فیلتر . . .",
  },
};
